import React from 'react'

const Languages = () => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
            <div className="col col-d-6 col-t-6 col-m-12 border-line-v LanguageBar">
                <div>
                    <div className="skill-title border-line-h">
                        <div className="icon"><i className="fa fa-flag"></i></div>
                        <div className="name">Languages</div>
                    </div>
                    <ul>
                        <li className="border-line-h">
                            <h3 className="progress-title">English</h3>
                            <div className="progress">
                                <div className="progress-bar p90" >
                                    <div className="progress-value">90%</div>
                                </div>
                            </div>
                        </li>
                        <li className="border-line-h">
                            <h3 className="progress-title">Marathi</h3>
                            <div className="progress">
                                <div className="progress-bar p60" >
                                    <div className="progress-value">60%</div>
                                </div>
                            </div>
                        </li>
                        <li className="border-line-h">
                            <h3 className="progress-title">Hindi</h3>
                            <div className="progress">
                                <div className="progress-bar p60" >
                                    <div className="progress-value">60%</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Languages;